var MailboxSearch = function() {

	var comp = $('[data-page="mailbox-search"]');

	this.init = function() {
		formValidate();
	}

	function formValidate() {
		comp.find('#form-mailbox-search').validate({
			rules: {
				mailboxFrom: "required",
				mailboxSubject: "required",
				valueDateFrom: "required",
				valueDateTo: "required"
			}
		});
	}
	return this.init();
}

